import {FC, useEffect, useState} from 'react'
import {api, CleanerPayout} from '../../services/api'
import {INK, MUTED, Section, Empty, fmtDate, money} from './ui'

/** Payouts already sent to the cleaner. */
const CleanerPaymentsPage: FC = () => {
  const [payouts, setPayouts] = useState<CleanerPayout[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.myCleanerPayouts().catch(() => []).then(setPayouts).finally(() => setLoading(false))
  }, [])

  const total = payouts.reduce((s, p) => s + parseFloat(p.amount || '0'), 0)

  return (
    <>
      <div style={{background: '#fff', borderRadius: 16, boxShadow: '0 6px 18px rgba(27,27,41,0.06)', border: '1px solid #eef0f4', padding: '20px 22px', marginBottom: 22}}>
        <div style={{fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: MUTED}}>Paid out to you, all time</div>
        <div style={{fontSize: 34, fontWeight: 900, color: INK, lineHeight: 1.1, marginTop: 4}}>{money(total)}</div>
      </div>

      <Section title='Payments to you' subtitle='Money already paid out to you.'>
        {loading ? (
          <Empty>Loading…</Empty>
        ) : payouts.length === 0 ? (
          <Empty>No payments yet.</Empty>
        ) : (
          payouts.map((p) => (
            <div key={p.id} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '13px 16px', borderTop: '1px solid #f1f3f7'}}>
              <div>
                <div style={{fontSize: 14.5, fontWeight: 700, color: INK}}>{money(p.amount)}</div>
                <div style={{fontSize: 12.5, color: MUTED, marginTop: 2}}>
                  {p.method === 'STRIPE' ? 'Sent to your bank' : 'Paid directly'} · {fmtDate(p.paidAt ?? p.createdAt)}
                </div>
              </div>
              <span style={{fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', borderRadius: 999, padding: '3px 9px', color: '#1f9d5b', background: 'rgba(3,149,64,0.12)'}}>Paid</span>
            </div>
          ))
        )}
      </Section>
    </>
  )
}

export {CleanerPaymentsPage}
